import React, { useState } from 'react';
import { Card, Button, Form } from "tabler-react";
import postObject from '../../../lib/postObject';
import ImageUpload from '../../../components/imageUpload';

const CategoryCreateModal = ({ closeMainModal, reload }) => {
  const [name, setName] = useState('');
  const [icon, setIcon] = useState('');
  const [image, setImage] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState('');

  const validateForm = () => {
    if (!name) {
      setError('Please enter category name');
      return false;
    }
    if (!icon) {
      setError('Please select an icon image');
      return false;
    }
    if (!image) {
      setError('Please select a photo image');
      return false;
    }
    return true;
  };

  const saveCategory = async () => {
    setError('');
    if (!validateForm()) return;

    try {
      setSaveLoading(true);
      await postObject('categories', { name, icon, image });

      if (typeof reload === 'function') {
        reload();
      }
      closeMainModal();
    } catch (err) {
      setError('Failed to create category. Please try again.');
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title>Create Category</Card.Title>
        <Card.Options>
          <Button
            size="sm"
            icon="x"
            onClick={closeMainModal}
          />
        </Card.Options>
      </Card.Header>
      <Card.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={(e) => { e.preventDefault(); saveCategory(); }}>
          <Form.Input
            name='name'
            label='Name'
            placeholder='Enter category name'
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <ImageUpload
            label="Icon"
            required
            uploadText="Click here to upload icon"
            alt="Icon Preview"
            onChange={(value) => setIcon(value)}
          />

          <ImageUpload
            label="Photo"
            required
            uploadText="Click here to upload photo"
            alt="Photo Preview"
            onChange={(value) => setImage(value)}
          />
        </Form>
      </Card.Body>
      <Card.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="primary"
            size="sm"
            className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
            onClick={saveCategory}
            disabled={saveLoading}
          >
            Save
          </Button>
          <Button
            color="secondary"
            size="sm"
            className="ml-2"
            onClick={closeMainModal}
            disabled={saveLoading}
          >
            Cancel
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default CategoryCreateModal;
